import React, { useEffect } from "react";

import { Tracker } from "@util/tracker";

export interface IntercomTrackingProps extends React.PropsWithChildren {
  componentName?: string;
}

export function IntercomTracking({
  componentName,
  children,
}: IntercomTrackingProps) {
  const tracker = Tracker.getInstance();

  useEffect(() => {
    tracker.trackEvent({
      event: "impression",
      eventAction: `${componentName}Impression`,
      eventLabel: componentName,
    });
  }, []);

  return (
    <div id={componentName} ref={tracker.registerComponent}>
      {children}
    </div>
  );
}

export function IntercomSlot({ children }: React.PropsWithChildren) {
  useEffect(() => {
    // Retrieve ABBA data for user
    // Get user's ABBA config for slot
    // Can maybe use @foundation/abba-client with useAbba(..) hook instead of generic useEffect
    // If the ABBA experiment returns a valid intercom Component that is not the same as the Component prop,
    // Use the intercom Component
  }, []);

  // Iterate over components and find the first one that renders (i.e., is not null)
  const component = React.Children.toArray(children).find((child) => {
    const childProps = (child as JSX.Element).props;

    return (
      childProps.criteria &&
      typeof childProps.criteria === "function" &&
      childProps.criteria()
    );
  });

  return <>{component}</>;
}
